<template>
  <div class="good-tags">
    <template v-if="goodTags.length">
      <tag
        v-for="(promote, index) in goodTags"
        :key="index"
        has-border
        :has-background="!!promote.backgroundColor"
        :primary-color="promote.textColor"
        :secondary-color="promote.frameColor"
        :corner-radius="promote.cornerRadius"
        :bg-color="promote.backgroundColor"
      >
        {{ promote.tag }}
      </tag>
    </template>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'
export default {
  components: {
    Tag
  },
  props: {
    ssu: {
      type: Object,
      default: () => {}
    },
    goodTags: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.good-tags {
  height: 16px;
  padding-top: 2px;
  overflow: hidden;
  box-sizing: content-box;

  @include flex(row, flex-start, flex-start, wrap);

  ::v-deep .good-tag {
    margin: 0 5px 5px 0;

    flex: none;
  }

  ::v-deep .member-price {
    margin: 0 5px 5px 0;

    flex: none;
  }
}
</style>
